import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    config: state.config,
    //auth: state.auth,
    intakeFormData: state.intakeFormData,
    // appointmentsCalendarPage: state.appointmentsCalendarPage,
    //appointmentsSelectedDayPage: state.appointmentsSelectedDayPage,
  })
});

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocalStorage.plugin]
});